import { useContext } from 'react';
import { AuthContext } from '../auth/AuthProvider';
import type { AuthContextValue } from '../auth/AuthProvider';

/**
 * Hook to access authentication state and methods.
 *
 * Must be used within an <AuthProvider>.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { user, signIn, signOut, loading } = useAuth();
 *
 *   if (loading) return <Spinner />;
 *   if (!user) return <SignInPage />;
 *
 *   return <div>Hello {user.email}</div>;
 * }
 * ```
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
